import { motion } from "framer-motion";
import { DoodleStar, DoodleAtom, DoodleLightbulb } from "@/components/Doodles";

const SplashScreen = ({ onGetStarted, onSignIn }) => (
  <div style={{
    minHeight: '100dvh', background: '#FFFEF9',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    padding: '32px 24px', maxWidth: 720, margin: '0 auto',
    position: 'relative',
  }}>
    {/* Doodle decorations */}
    <div style={{ position: 'absolute', top: 32, left: 24, pointerEvents: 'none' }}>
      <DoodleStar color="#448AFF" opacity={0.2} size={14} />
    </div>
    <div style={{ position: 'absolute', top: 80, right: 28, pointerEvents: 'none' }}>
      <DoodleAtom color="#66BB6A" opacity={0.15} size={12} />
    </div>
    <div style={{ position: 'absolute', bottom: 120, left: 20, pointerEvents: 'none' }}>
      <DoodleLightbulb color="#FFD740" opacity={0.2} size={14} />
    </div>

    <div style={{ textAlign: 'center', marginBottom: 40 }}>
      <img src="/logo-book.png" alt="YOU" style={{ width: 180, height: 180, objectFit: 'contain', display: 'block', margin: '0 auto -4px' }} />
      <img src="/logo-you-text.png" alt="YOU" style={{ height: 70, objectFit: 'contain', display: 'block', margin: '0 auto 10px' }} />
      <img src="/logo-subtitle.png" alt="Your Own Understanding" style={{ height: 26, objectFit: 'contain', display: 'block', margin: '0 auto 20px' }} />
      <div style={{ fontSize: 18, color: '#4A4A5A', lineHeight: 1.5, maxWidth: 260, margin: '0 auto' }}>
        Turn any school topic into a fun story with Priya &amp; Bunty
      </div>
    </div>

    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center', marginBottom: 44 }}>
      {[
        { label: 'Audio stories', icon: '🎙️' },
        { label: 'Quiz yourself', icon: '🧠' },
        { label: 'Grow your pet', icon: '🐾' },
        { label: 'Instant answers', icon: '⚡' },
      ].map((f, i) => (
        <motion.div
          key={f.label}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 + i * 0.1, type: 'spring', stiffness: 300, damping: 25 }}
          style={{
            background: '#FFFFFF', borderRadius: 14,
            padding: '8px 16px', fontSize: 16, fontWeight: 400, color: '#4A4A5A',
            fontFamily: "'Patrick Hand', cursive",
            border: '1.5px dashed #CCCCCC',
          }}
        >{f.icon} {f.label}</motion.div>
      ))}
    </div>

    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.95, rotate: -1 }}
        onClick={onGetStarted}
        style={{
          width: '100%', padding: '15px 0', borderRadius: 12, fontSize: 22,
          fontWeight: 400, fontFamily: "'Patrick Hand', cursive",
          background: '#448AFF',
          color: '#fff', border: 'none', cursor: 'pointer',
        }}
      >
        Get Started 🚀
      </motion.button>
      <motion.button
        whileTap={{ scale: 0.95 }}
        onClick={onSignIn}
        style={{
          width: '100%', padding: '13px 0', borderRadius: 12, fontSize: 16,
          fontWeight: 400, fontFamily: "'Patrick Hand', cursive",
          background: 'transparent',
          color: '#448AFF', border: '1.5px dashed #448AFF',
          cursor: 'pointer',
        }}
      >
        Already have an account? Sign in
      </motion.button>
    </div>
  </div>
);

export default SplashScreen;
